import { useMutation } from '@tanstack/react-query'

import { analyzeEvidence } from '@src/api'
import { DefaultApiAnalyzeEvidenceRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks'

export const useAnalyzeEvidence = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiAnalyzeEvidenceRequest) =>
      analyzeEvidence(axiosInstance, params),
  })
}
